'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.minutesAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/minutesAgo.js
// module id = 261
// module chunks = 1